import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class ColectiveAgreement extends Resource {
    public override type = 'colectiveAgreements';

    @prop()
    public name!: string;

}